var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-icon',{attrs:{"name":_vm.direction,"size":_vm.width,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }